export const LOAD_CHANGELOG = 'changelog/LOAD_CHANGELOG';
export const CLEAR_CHANGELOG = 'changelog/CLEAR_CHANGELOG';